import React, { useState } from "react";
import bgImg from "../assets/test.jpg";
import user1 from "../assets/user.png";
import user2 from "../assets/user.png";
import user3 from "../assets/user.png";

const testimonials = [
  {
    text: "Profitly transformed how I handle my books. Their team made tax season stress-free, and I actually saved more than I expected.",
    name: "Melvin Rosario",
    role: "Executive",
    img: user1,
  },
  {
    text: "Excellent GST and compliance support. Everything is smooth and well-managed.",
    name: "Rohit Sharma",
    role: "Business Owner",
    img: user2,
  },
  {
    text: "Highly professional team. Helped me with ITR and tax planning efficiently.",
    name: "Ankit Verma",
    role: "Freelancer",
    img: user3,
  },
];

const TestimonialSection = () => {
  const [index, setIndex] = useState(0);

  const prevSlide = () => {
    setIndex((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1));
  };

  const nextSlide = () => {
    setIndex((prev) => (prev === testimonials.length - 1 ? 0 : prev + 1));
  };

  const t = testimonials[index];

  return (
    <>
      <style>{`
        .testimonial-section {
          position: relative;
          padding: 100px 20px;
          color: white;
        }

        .testimonial-section::before {
          content: "";
          position: absolute;
          inset: 0;
          background: url(${bgImg}) center/cover no-repeat;
          z-index: 1;
        }

        .testimonial-section::after {
          content: "";
          position: absolute;
          inset: 0;
          background: rgba(15, 61, 46, 0.85);
          z-index: 2;
        }

        .testimonial-container {
          position: relative;
          z-index: 3;
          max-width: 1100px;
          margin: auto;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 60px;
        }

        .testimonial-left {
          max-width: 480px;
        }

        .testimonial-left h2 {
          font-size: 38px;
          line-height: 1.3;
          margin-bottom: 20px;
        }

        .testimonial-left p {
          color: #dcdcdc;
          margin-bottom: 30px;
        }

        /* 🔥 BUTTONS FIXED */
        .nav-btns {
          display: flex;
          gap: 15px;
        }

        .nav-btn {
          width: 55px;
          height: 55px;
          border-radius: 50%;
          background: #7ED957;

          display: flex;
          align-items: center;
          justify-content: center;

          cursor: pointer;
          transition: 0.3s;
        }

        .nav-btn span {
          font-size: 26px; /* ✅ bigger arrows */
          font-weight: bold;
          color: black;
        }

        .nav-btn:hover {
          background: #D4AF37;
        }

        /* CARD */
        .testimonial-card {
          background: white;
          color: #333;
          padding: 40px;
          border-radius: 20px;
          max-width: 480px;
          box-shadow: 0 20px 50px rgba(0,0,0,0.2);
          transition: 0.4s;
        }

        .quote {
          font-size: 40px;
          color: #7ED957;
          margin-bottom: 20px;
        }

        .testimonial-text {
          margin-bottom: 25px;
          line-height: 1.6;
        }

        .user {
          display: flex;
          align-items: center;
          gap: 12px;
        }

        .user img {
          width: 45px;
          height: 45px;
          border-radius: 50%;
        }

        .user h4 {
          margin: 0;
        }

        .user span {
          font-size: 14px;
          color: #777;
        }

        @media (max-width: 900px) {
          .testimonial-container {
            flex-direction: column;
            text-align: center;
          }

          .nav-btns {
            justify-content: center;
          }
        }
      `}</style>

      <section className="testimonial-section">
        <div className="testimonial-container">

          {/* LEFT */}
          <div className="testimonial-left">
            <h2>
              Client Success Stories That Speak for Themselves
            </h2>

            <p>
              We help businesses simplify taxes, stay compliant,
              and grow with confidence.
            </p>

            <div className="nav-btns">
              <div className="nav-btn" onClick={prevSlide}>
                <span>‹</span>
              </div>
              <div className="nav-btn" onClick={nextSlide}>
                <span>›</span>
              </div>
            </div>
          </div>

          {/* RIGHT */}
          <div className="testimonial-card">
            <div className="quote">“</div>

            <div className="testimonial-text">
              {t.text}
            </div>

            <div className="user">
              <img src={t.img} alt="" />
              <div>
                <h4>{t.name}</h4>
                <span>{t.role}</span>
              </div>
            </div>
          </div>

        </div>
      </section>
    </>
  );
};

export default TestimonialSection;